export enum USER_ROLES {
  Admin = 1,
  Brand = 2,
  Retail = 3,
}
